import { render, staticRenderFns } from "./SubmitApplication.vue?vue&type=template&id=c5190454&scoped=true"
import script from "./SubmitApplication.vue?vue&type=script&lang=js"
export * from "./SubmitApplication.vue?vue&type=script&lang=js"
import style0 from "./SubmitApplication.vue?vue&type=style&index=0&id=c5190454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5190454",
  null
  
)

export default component.exports